module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((!_vm.lazy || _vm.loaded) || _vm.active) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "el-tab-pane",
    attrs: {
      "role": "tabpanel",
      "aria-hidden": !_vm.active,
      "id": ("pane-" + _vm.paneName),
      "aria-labelledby": ("tab-" + _vm.paneName)
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-469c8406","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ni-ui/tabs/tab-pane/tab-pane.vue
// module id = pyUj
// module chunks = 81